import React from 'react';

class RowItemKetQuaTTCP extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.ChuDon}</td>
        <td>{this.props.item.CMTND}</td>
        <td>{this.props.item.DiaChi}</td>
        <td>{this.props.item.NoiDung}</td>
      </tr>
    )
  }
}

export default RowItemKetQuaTTCP;



// WEBPACK FOOTER //
// ./src/components/modules/tra-cuu/RowItemKetQuaTTCP.jsx